<template>
    <div :style="cssProps">
        <transition name="fade">
            <div class="modal-mask" v-if="tutorialStepCount == 0">
                <div class="modal-wrapper">
                    <div class="modal-container tutorial-container" id="tutorial-box">
                        <button class="btn btn-close btn-ico" @click.prevent="toggleTutorialStep(4)" style="position: absolute; right: 0px; top: 0px; margin: 10px;"><span class="ico material-icons">close</span></button>
                        <p><strong>Dit is je nieuwe website.</strong></p>
                        <p>Wij gaan je helpen met aanpassen.</p>
                        <button type="submit" @click.prevent="toggleTutorialStep(1), addFocusToId('hero-title')" class="btn btn-gradient-primary">Ok, laten we beginnen</button>
                    </div>
                </div>
            </div>
        </transition>

        <transition name="fade">
            <div class="modal-mask" v-if="tutorialStepCount == 1">
                <div class="modal-wrapper">
                    <div class="modal-container tutorial-container top-arrow" id="tutorialbox2">
                        <button class="btn btn-close btn-ico" @click.prevent="toggleTutorialStep(4)" style="position: absolute; right: 0px; top: 0px; margin: 10px;"><span class="ico material-icons">close</span></button>
                        <strong>Klik op deze tekst om het aan te passen.</strong>
                    </div>
                </div>
            </div>
        </transition>

        <transition name="fade">
            <div class="modal-mask" v-if="tutorialStepCount == 3">
                <div class="modal-wrapper">
                    <div class="modal-container tutorial-container" id="tutorialbox3">
                        <p><strong>Goed zo. Probeer zo ook andere teksten aan te passen.</strong></p>
                        <button type="submit" @click.prevent="toggleTutorialStep(4)" class="btn btn-gradient-primary">Ok</button>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import Modal from '../modal/Modal.vue';

import { userService } from '../../services/user.service.js';
import { authHeader } from '../../services/auth-header.js';

import axios from 'axios';

export default {
    components:{
        Modal,
    },
    props:{
      websiteid: {
          type: String
      },
      tutorialStepCount: {
          type: Number
      },
      sitedata: {
          type: Object
      }
    },
    computed: {
        cssProps() {
            return {
                '--left-pos': this.leftpos,
                '--right-pos': this.rightpos,
                '--top-pos': this.toppos,
                '--bottom-pos': this.bottompos,
            }
        }
    },
    watch: {
        tutorialStepCount(value) {
            if(value == 2){
                var element = document.getElementById('hero-title');
                element.classList.remove("tutorial-focus");
            }
            if(value == 4){
                this.saveTutorialState()
            }
        }
    },
    data: function() {
        return{
            leftpos: '',
            rightpos: '',
            toppos: '',
            bottompos: '',
            tutorial1: true,
            tutorial2: false,
            tutorial3: false,
            tutorial4: false,
            tutorial5: false,
            tutorial6: false
        }
    },
    methods: {
        toggleTutorialStep(step){
            this.$emit('clicked', step)
        },
        addFocusToId(elementId){
            var element = document.getElementById(elementId);
            var rect = element.getBoundingClientRect();
            element.classList.add("tutorial-focus");
            this.leftpos = rect.left+20 + 'px';
            this.bottompos = rect.bottom+10 + 'px';
        },
        saveTutorialState(){

            const requestOptions = {
              headers: authHeader()
            }

            const data = {
                websiteid: this.websiteid,
                dbentry: 'hastutorial',
                content: false
            }

            axios.patch(process.env.VUE_APP_ROOT_API+'/settings/', data, requestOptions)
            .then(response => {
            })
        }
    }
}
</script>

<style lang="scss">
    #tutorialbox2{
        position: absolute;
        left: var(--left-pos);
        top: var(--bottom-pos);
    }

    .tutorial-container{
        border-radius: 25px;
        max-width: 400px;
        box-shadow: 0 10px 80px rgba(0, 0, 0, .5);
        padding: 25px 30px 28px;
        position: relative;
        background: $action !important;
        color: $color-white !important;
        z-index: 9999;

        p{
            line-height: 1.4;
        }

        .btn{
            color: $action !important;
            background: $color-white !important;
        }

        &.top-arrow{
            border-radius: 0 25px 25px 25px;
            margin-left: auto;
            margin-right: auto;

            &:after{
                border-right: 20px solid transparent;
                border-bottom: 20px solid $action;
                left: 0;
                top: -20px;
            }
        }

        &:after{
            content: '';
            display: block;
            width: 0; 
            height: 0; 
            position: absolute;
        }
    }

    .tutorial-focus{
        z-index: 9999;
        position: relative;
        border-radius: 10px;
        //border-bottom: 3px solid aqua
        //box-shadow: 0 0 0 3px aqua;

        &:not(.btn){
            background: #00eeff17;
        }
    }

  @media #{$phone} {
    .tutorial-container {
      width: calc(100% - 40px) !important;
    }
  }

</style>